import * as React from 'react'
import styled, { css } from 'styled-components'

import { RoundButton } from './button/RoundButton'

import * as colors from '../constants/colors'
import * as glyphs from '../icons/glyphs'

import * as S from '../styles'

import { hexToRgb } from '../utils'

const icons = {
  discord: glyphs.thirdParty.Discord,
  facebook: glyphs.thirdParty.Facebook,
  google: glyphs.thirdParty.Google,
  instagram: glyphs.thirdParty.Instagram,
  linkedin: glyphs.thirdParty.Linkedin,
  messenger: glyphs.thirdParty.Messenger,
  twitter: glyphs.thirdParty.Twitter,
  whatsapp: glyphs.thirdParty.WhatsApp,
}

const bgColors = {
  discord: colors.TERTIARY_DISCORD,
  facebook: colors.TERTIARY_FACEBOOK,
  google: colors.TERTIARY_GOOGLE,
  instagram: colors.TERTIARY_INSTAGRAM,
  linkedin: colors.TERTIARY_LINKEDIN,
  messenger: colors.TERTIARY_MESSENGER,
  twitter: colors.TERTIARY_X,
  whatsapp: colors.TERTIARY_WHATSAPP,
}

export type SocialButtonProps = Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'color'> & {
  platform: 'facebook' | 'twitter' | 'messenger' | 'linkedin' | 'instagram' | 'whatsapp' | 'google' | 'discord'
  style?: 'block' | 'round'
}

export function SocialButtonComponent({
  children,
  platform,
  style = 'block',
  ...buttonProps
}: SocialButtonProps): React.ReactElement<SocialButtonProps> {
  const PlatformIcon = icons[platform]
  return style === 'block' ? (
    <S.button.CallToAction {...buttonProps} $onlyGlyph={!children}>
      <PlatformIcon />
      {children}
    </S.button.CallToAction>
  ) : (
    <RoundButton {...buttonProps} fitToParent prefixIcon={<PlatformIcon size={18} />}>
      {children}
    </RoundButton>
  )
}

export const SocialButton = styled(SocialButtonComponent)<SocialButtonProps>`
  ${({ platform }) => {
    if (platform in bgColors) {
      return css`
        background-color: ${bgColors[platform]};

        &:hover {
          background-color: ${hexToRgb(bgColors[platform], 0.85)};
        }
      `
    }
  }}
`
SocialButton.displayName = 'SocialButton'
